















import { defineComponent } from '@vue/composition-api'

import { IReceipt } from '@/types/receipt'
import { ReceiptValidation } from '@/types/ocr'

import { AppToggleButton } from '@/components/atoms'

type Props = {
  receipt: IReceipt
  validation: ReceiptValidation
  isValidationNg: boolean
  isFirstReceipt: boolean
  isLastReceipt: boolean
}

export default defineComponent({
  name: 'NextActions',
  components: { AppToggleButton },
  props: {
    receipt: {
      type: Object,
      default: () => ({}),
    },
    validation: {
      type: Object,
      default: () => ({}),
    },
    isValidationNg: {
      type: Boolean,
      default: false,
    },
    isFirstReceipt: {
      type: Boolean,
      default: false,
    },
    isLastReceipt: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, context) {
    const onClickNextReceipt = () => {
      context.emit('on-click-next-receipt')
    }

    return {
      onClickNextReceipt,
    }
  },
})
